module.exports = __webpack_public_path__ + "static/keralit-3-8ed7c649fbda75886d4847430ebe83f3.jpg";